class SendEmailRequest {

    getRequestSendEmail = (datosEnvioCorreo) => {
        return {
            "datos": {
                "correo": datosEnvioCorreo.correo,
                "nombre": datosEnvioCorreo.nombre,
                "titulo": datosEnvioCorreo.titulo
            }
        };
    }
}

export default SendEmailRequest;